import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import notify from 'Common/utils/notify';
import { toast } from 'react-toastify';
import Button from 'Common/components/Button';
import ModalTitle from 'Common/components/Modals/ModalTitle';
import Modal from 'Common/components/Modals/Modal';
import useDeleteCustomQuestionFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/DeleteCustomQuestion/hooks/deleteCustomQuestionFunction/useDeleteCustomQuestionFunction';

const DeleteCustomQuestionModal = ({ question, onCancel, onDelete }) => {
    const deleteCustomQuestion = useDeleteCustomQuestionFunction(question.id);

    const [isDeleting, setIsDeleting] = useState(false);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    const handleConfirm = async () => {
        setIsDeleting(true);

        try {
            await deleteCustomQuestion();
            await onDelete();

            notify('Die Frage wurde erfolgreich gelöscht', {
                type: toast.TYPE.SUCCESS,
            });
        } catch (error) {
            if (!axios.isCancel(error)) {
                notify('Die Frage konnte nicht gelöscht werden', {
                    type: toast.TYPE.ERROR,
                });
            }
        }

        setIsDeleting(false);
    };

    return (
        <Modal
            isOpen
            onRequestClose={isDeleting ? undefined : onCancel}
            buttons={
                <>
                    <Button
                        text
                        dark
                        type="button"
                        onClick={onCancel}
                        disabled={isDeleting}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="button"
                        isLoading={isDeleting}
                        disabled={isDeleting}
                        onClick={handleConfirm}
                    >
                        Löschen
                    </Button>
                </>
            }
        >
            <ModalTitle>Löschung der eigenen Frage</ModalTitle>
            <p>
                Wenn du den Prozess mit "Weiter" fortsetzt wird die Frage und
                die entsprechenden Antworten unwiderruflich aus dem Projekt
                gelöscht.
            </p>
        </Modal>
    );
};

DeleteCustomQuestionModal.propTypes = {
    question: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default DeleteCustomQuestionModal;
